




































































import Vue from 'vue'
import { DatePeriod } from '@/model/DatePeriod'
import { GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import moment from 'moment'
import { DatePeriodEnum } from '@/types/enums'
import { FETCH_STATISTIC_DATA } from '@/store/action-types'
import ProgressCircular from '@/components/ProgressCircular.vue'
import { MonthStatisticPayload } from '@/types/payload'
import { MonthStatistic } from '@/model/planning/MonthStatistic'

interface ComponentData {
  positions: any
  loading: boolean

  gridData: MonthStatistic[]
  headers: any
  overlayNoRowsTemplate: string
  period: DatePeriod | undefined
}

export default Vue.extend({
  name: 'MonthStatisticDialog',

  components: {
    ProgressCircular
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },
    isMonthStatisticDisabled: Boolean,
    currentPeriod: Object as () => DatePeriod,
    department: Number,
    monthStatisticStyleData: Object as () => any
  },

  data (): ComponentData {
    return {
      positions: {
        clientX: undefined,
        clientY: undefined,
        movementX: 0,
        movementY: 0
      },
      loading: false,

      gridData: [],
      headers: [
        { text: this.$t('monthStatistic.employee').toString(), value: 'employee', align: 'start', groupable: false },
        { text: this.$t('monthStatistic.capacityHrsMonth').toString(), value: 'BG_STD', align: 'right', groupable: false },
        { text: this.$t('monthStatistic.capacityMonth').toString(), value: 'BG', align: 'right', groupable: false },
        { text: this.$t('monthStatistic.plannedHrsMonth').toString(), value: 'Planung_STD', align: 'right', groupable: false },
        { text: this.$t('monthStatistic.plannedMonth').toString(), value: 'Planung', align: 'right', groupable: false },
        { text: this.$t('monthStatistic.plannedOnSaturday').toString(), value: 'Planung_Samstag', align: 'right', groupable: false },
        { text: this.$t('monthStatistic.plannedOnSunday').toString(), value: 'Planung_Sonntage', align: 'right', groupable: false },
        { text: this.$t('monthStatistic.plannedVacation').toString(), value: 'Planung_Urlaub', align: 'right', groupable: false },
      ],
      overlayNoRowsTemplate: this.$t('errors.noRowsToShow').toString(),
      period: undefined
    }
  },

  watch: {
    currentPeriod (newVal: DatePeriod): void {
      if(newVal) {
        this.period = this.currentPeriod
        this.fetchData()
      }
    },

    department (newVal: number | undefined): void {
      if(newVal) {
        this.fetchData()
      }
    }
  },

  computed: {
    getPosition (): Object {
      const top : number = (window.innerHeight - 100 - 400) / 2
      const left : number = (window.innerWidth - 890) / 2
      return {top: `${top}px`, left: `${left}px`}
    },

    selectedLocale (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    },

    getTitle (): string {
      let begin = moment(this.currentPeriod.startDate).startOf(DatePeriodEnum.Month)
      let end = moment(this.currentPeriod.endDate).endOf(DatePeriodEnum.Month)

      if(this.period) {
        begin = moment(this.period.startDate).startOf(DatePeriodEnum.Month)
        end = moment(this.period.endDate).endOf(DatePeriodEnum.Month)
      }

      let beginStr, endStr

      const beginMonth = begin.format('MMM')
      const endMonth = end.format('MMM')

      if (beginMonth === endMonth) {
        beginStr = begin.format('DD')
        endStr = end.locale(this.selectedLocale).format('DD MMM')
      } else {
        beginStr = begin.locale(this.selectedLocale).format('DD MMM')
        endStr = end.locale(this.selectedLocale).format('DD MMM')
      }
      const yearStr = end.format('YYYY')

      return `${beginStr} - ${endStr} ${yearStr}`
    }
  },

  methods: {
    onCloseButtonClick (): void {
      this.$emit('close')
    },

    onRefreshButtonClick (): void {
      this.fetchData()
    },

    async fetchData (): Promise<void> {
      this.period = this.currentPeriod
      const payload: MonthStatisticPayload = {
        year: parseInt(moment(this.currentPeriod.startDate).format('YYYY')),
        month: this.currentPeriod.number,
        department: this.department
      }

      try {
        this.loading = true
        const response: MonthStatistic[] = await this.$store.dispatch(FETCH_STATISTIC_DATA, payload)
        if (response) {
          this.gridData = response
        }
      } catch (e) {
      } finally {
        this.loading = false
      }
    },

    dragMouseDown: function (event: any) {
      event.preventDefault()
      this.positions.clientX = event.clientX
      this.positions.clientY = event.clientY
      document.onmousemove = this.elementDrag
      document.onmouseup = this.closeDragElement
    },

    elementDrag: function (event: any) {
      // @ts-ignore
      const container: HTMLElement = this.$refs['draggableContainer']
      event.preventDefault()

      this.positions.movementX = this.positions.clientX - event.clientX
      this.positions.movementY = this.positions.clientY - event.clientY
      this.positions.clientX = event.clientX
      this.positions.clientY = event.clientY

      if((container.offsetTop - this.positions.movementY) > -64 && (container.offsetTop - this.positions.movementY + container.clientHeight + 64) < event.view.innerHeight) {
        container.style.top = (container.offsetTop - this.positions.movementY) + 'px'
      } else if ((container.offsetTop - this.positions.movementY) < -64) {
        container.style.top = -64 + 'px'
      } else if ((container.offsetTop - this.positions.movementY) + container.clientHeight + 64 > event.view.innerHeight) {
        container.style.top = (event.view.innerHeight - (container.clientHeight + 64)) + 'px'
      }

      if((container.offsetLeft - this.positions.movementX) > 0 && (container.offsetLeft - this.positions.movementX + container.clientWidth + 18) < event.view.innerWidth) {
        container.style.left = (container.offsetLeft - this.positions.movementX) + 'px'
      } else if((container.offsetLeft - this.positions.movementX) < 0) {
        container.style.left = 0 + 'px'
      } else if((container.offsetLeft - this.positions.movementX + container.clientWidth + 18) > event.view.innerWidth) {
        container.style.left = (event.view.innerWidth - container.clientWidth - 18) + 'px'
      }
    },

    closeDragElement () {
      document.onmouseup = null
      document.onmousemove = null
    }
  },

  mounted (): void {
    this.period = this.currentPeriod

    // @ts-ignore
    const container: HTMLElement = this.$refs['draggableContainer']
    if(container) {
      container.style.top = `${80}px`
      container.style.left = `${24}px`
    }

    let table = document.getElementsByClassName('dataTable')
    if(table && table[0]) {
      if(this.monthStatisticStyleData.height) {
        // @ts-ignore
        table[0].style.height = `${this.monthStatisticStyleData.height + 28}px`
      }
      if(this.monthStatisticStyleData.width) {
        // @ts-ignore
        table[0].style.width = `${this.monthStatisticStyleData.width}px`
      }
    }

    this.fetchData()
  }
})
